export enum ActionType {
  FLASH_MESSAGES = 'flash-message',
  OPEN_SUB_MENU = 'open-submenu',
  CLOSE_SUB_MENU = 'close-submenu',
}
